/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { TenantModuleApi } from '../api/tenantmodule.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantModuleData,TenantModule } from '../../../interfaces/masters/tenantmodule';

@Injectable()
export class TenantModuleService extends TenantModuleData {

  constructor(private api: TenantModuleApi) {
    super();
  }


  list(url: string): Observable<TenantModule[]> {
    return this.api.list(url);
  }


  createTenantModule(url: string, data:any[]): Observable<any> {
    return this.api.createTenantModule(url,data);
  }

  update(url: string, data:TenantModule): Observable<TenantModule> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
